import React from 'react';
import './StandardButton.css';

const StandardButton = ({ label, href }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="standard-btn-link">
    <button className="standard-btn">{label}</button>
  </a>
);

export default StandardButton;
